import { PageHeader } from 'ui/pageHeader';
import { PAGE_HEADER_VARIANTS } from 'ui/pageHeader/constants';
import { Member } from '../../types';
import { fullName } from '../../utils';
import { PageHeaderSubSection } from './PageHeaderSubSection';
import { PageHeaderActions } from './PageHeaderActions';

export const MemberDetailsPageHeader = ({ member }: { member: Member }) => (
  <PageHeader
    variant={PAGE_HEADER_VARIANTS.SECONDARY}
    breadcrumb={{
      content: 'Members',
      href: '/members',
    }}
    pageActions={<PageHeaderActions member={member} />}
    pageSubSection={<PageHeaderSubSection member={member} />}
  >
    {fullName(member)}
  </PageHeader>
);
